import participantProfileContainer from "./ParticipantProfile.container";

export default participantProfileContainer;
